import { render, staticRenderFns } from "./ProcInstRuns.vue?vue&type=template&id=301ac808&"
import script from "./ProcInstRuns.vue?vue&type=script&lang=js&"
export * from "./ProcInstRuns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports